import React from 'react';
import { InlineWidget, PopupButton, useCalendlyEventListener } from 'react-calendly';

// InlineCalendly widget for embedding calendar
export const CalendlyWidget: React.FC<{ url: string; styles?: React.CSSProperties }> = ({ url, styles }) => {
  // Listen for Calendly events
  useCalendlyEventListener({
    onEventScheduled: (e) => {
      console.log('Event scheduled:', e.data);
    },
  });

  return (
    <div className="calendly-wrapper rounded shadow-sm overflow-hidden">
      <InlineWidget 
        url={url} 
        styles={{ 
          height: '700px', 
          ...styles 
        }} 
      />
    </div>
  );
};

// PopupCalendly button for opening scheduling popup
export const CalendlyButton: React.FC<{ 
  url: string; 
  text: string; 
  className?: string;
}> = ({ url, text, className = "btn btn-primary" }) => {
  return (
    <PopupButton
      url={url}
      rootElement={document.getElementById('root')!}
      text={text}
      className={className}
    />
  );
};
